export const nav = {
    'NAV': {
        'DASHBOARD': 'Dashboard',
        'MENU_WITH_TITLE': 'Herramientas',
        'MENU_WITH_TITLE_ITEM_1': 'Menu with title item 1',
        'MENU_WITH_TITLE_ITEM_2': 'Menu with title item 2',
        'NAV_WITH_SUBMENU': 'Nav with submenu',
        'SUBMENU_1': 'Submenu 1',
        'SUBMENU_2': 'Submenu 2',
        'SUBMENU_WITH_TITLE': 'Submenu with title',
        'MENU': 'Menu'
    }
}